import templateConfig from '../../../Template/config'
import main from './main'
import metadata from './metadata'
import components from './components'
import sidebar from './sidebar'
const config = {
  ...templateConfig,
  main,
  components,
  metadata,
  sidebar
}

export {config}
export default config
